const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';

export interface ApiErrorResponse {
  error: { code: string; message: string; details?: unknown };
}

export class ApiClientError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number,
  ) {
    super(message);
  }
}

export async function apiFetch<T>(
  path: string,
  options: RequestInit & { token?: string | null } = {},
): Promise<T> {
  const { token, ...init } = options;
  const headers = new Headers(init.headers);
  const isFormData = typeof FormData !== 'undefined' && init.body instanceof FormData;
  if (!headers.has('Content-Type') && init.body && !isFormData) {
    headers.set('Content-Type', 'application/json');
  }
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  });

  const json = (await res.json()) as T | ApiErrorResponse;
  if (!res.ok) {
    const err = json as ApiErrorResponse;
    throw new ApiClientError(
      err.error?.code ?? 'UNKNOWN',
      err.error?.message ?? 'Erro',
      res.status,
    );
  }
  return json as T;
}

export function getApiBase(): string {
  return API_BASE;
}
